import React from 'react';

function formatValue(v: unknown): string {
  if (v == null) return '—';
  if (typeof v === 'string' || typeof v === 'number') return String(v);
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  return JSON.stringify(v);
}

export function KeyValueGrid({
  rows,
  columns = 2,
}: {
  rows: Record<string, unknown>[];
  columns?: 1 | 2;
}) {
  if (!rows?.length) return null;

  const entries = rows.flatMap((r) => {
    const obj = r as Record<string, unknown>;
    if (obj.label != null && obj.value != null) {
      return [{ key: String(obj.label), value: obj.value }];
    }
    return Object.entries(obj).map(([k, v]) => ({ key: k, value: v }));
  });

  return (
    <dl
      className={`grid gap-2.5 text-sm ${
        columns === 2 ? 'grid-cols-1 xl:grid-cols-2' : 'grid-cols-1'
      }`}
    >
      {entries.map(({ key, value }, i) => (
        <div
          key={i}
          className="rounded-lg border border-border/50 bg-surface-sunken/20 px-3 py-2.5 shadow-sm"
        >
          <dt className="mb-1 text-[11px] font-medium uppercase tracking-[0.08em] text-text-tertiary">
            {String(key).replace(/_/g, ' ')}
          </dt>
          <dd className="text-[13px] leading-[1.65] text-foreground wrap-break-word">
            {formatValue(value)}
          </dd>
        </div>
      ))}
    </dl>
  );
}
